import type { ReactElement } from "react";
import { Optionen } from "@kundeninfo/ui/me-design";
import { ARTICLE_TEXT as T } from "./articleTexts.js";

/** Die Spaltenzahl der Kachelansicht (798): 2, 3 oder 4, je Benutzer gespeichert, Vorgabe 3. */
export type ProduktSpalten = 2 | 3 | 4;

/** Die drei Stufen in ihrer Folge — die Segmente und der Prüfer der Wahl lesen dieselbe Liste. */
export const PRODUKT_SPALTEN: readonly ProduktSpalten[] = [2, 3, 4];

const alsSpalten = (wert: string | undefined): ProduktSpalten | null =>
  PRODUKT_SPALTEN.find((n) => String(n) === wert) ?? null;

/**
 * Die SPALTENWAHL rechts in der Werkzeugzeile (798): leise Beschriftung „Spalten“ und drei gleich breite Segmente
 * (`Optionen darstellung="segmente"`). Sie hält keinen Zustand — der Wert kommt aus der Sitzung, die Wahl geht an den
 * Aufrufer, der ihn sofort anwendet und nebenläufig speichert. Breite und Höhe ändern sich durch die Wahl nicht
 * (Hausregel „Leiste kippt nie“): drei feste Segmente, nur das gefüllte wechselt.
 */
export function Spaltenwahl(p: { wert: ProduktSpalten; onWahl: (n: ProduktSpalten) => void }): ReactElement {
  return (
    <span className="bart__spalten">
      <span className="bart__spalten-titel" aria-hidden="true">{T.columns}</span>
      <Optionen darstellung="segmente" richtung="waagerecht" aria-label={T.columnsLabel} wert={String(p.wert)}
        onGeaendert={(d) => { const n = alsSpalten(d.wert); if (n !== null) p.onWahl(n); }}>
        {PRODUKT_SPALTEN.map((n) => <option key={n} value={String(n)}>{n}</option>)}
      </Optionen>
    </span>
  );
}
